/** global VCOM */

VCOM.navigationList = VCOM.navigationList || null;
VCOM.portletInitCallback = () => ({});
VCOM.acl = null;

const VcomProvider = VCOM;
export default VcomProvider;
